import { Textfields } from 'experience-kit';

class Newsletter {
  constructor () {
    if( document.querySelector('.template-community-menu.design-wednesday') === null &&
      document.querySelector('.cancelar-suscripcion') === null ) {
      return;
    }

    this.formClass = 'form-content';
    this.successClass = 'newsletter--success';
    this.prod_hosts = ["ec2-34-240-232-153.eu-west-1.compute.amazonaws.com", "d1zx188tqaw0kd.cloudfront.net", "design.bbvaexperience.com", "revision-j95bw15y.openweb.bbva"];
    this.sandbox_hosts = ["edicion-kaghs10c.openweb.bbva", "revision-kaghs10c.openweb.bbva", "kaghs10c.openweb.bbva", "dev-design.bbvaexperience.com"];

    if( document.querySelector('.newsletter--subscribe') != null ) {
      this.disableButton(this.formClass);
      //this.hideSuccessMesage(this.formClass);
    }
    document.addEventListener('DOMContentLoaded', this.setupEvents.bind(this));

  }

  setupEvents() {
    let subscriber_timeout = null;

    if( document.querySelector('.' + this.formClass) != null ) {
      window.setTimeout(() => {
        document.querySelectorAll(`.${this.formClass} .form-group`).forEach(formgroup => {
          formgroup.classList.add('form__item', 'input__wrapper');
          if( formgroup.querySelector('label') != null ) {
            formgroup.querySelector('label').classList.add('input-control__label');
            formgroup.appendChild(formgroup.firstElementChild);

            /*if( formgroup.querySelector('label').nextElementSibling.classList.contains('checkbox') ){
            } else */if( formgroup.querySelector('.textfield') != null ) {
              formgroup.querySelector('label').classList.add('input__label');
              formgroup.classList.add('label__out');
              let button = document.createElement('button');
                  button.setAttribute('type', 'button');
                  button.classList.add('ui-close', 'clear-btn');
              let error_msg = document.createElement('div');
                  error_msg.classList.add('ui-warning', 'input__error-msg');
                  error_msg.innerHTML = 'Formato de correo electrónico no válido';
              formgroup.appendChild(button);
              formgroup.appendChild(error_msg);
            }
          }
        });
        Textfields.init({ initSelector: '.textfield'});

        //Subscriber
        let subscriberInputElement = document.querySelector( `.${this.formClass} input[name="subscribe-email"]` );
        if( subscriberInputElement ) {
          subscriberInputElement.addEventListener('blur', () => {
            this.validateElement( subscriberInputElement )
            this.isValidForm();
          });
          subscriberInputElement.addEventListener('keyup', () => {
            clearTimeout( subscriber_timeout );

            subscriber_timeout = setTimeout( () => {
              this.validateElement(subscriberInputElement);
              this.isValidForm();
            }, 1000);
          });
        }

        //LOPD
        let lopdInputElement = document.querySelector( `.${this.formClass} input[name="subscribe-lopd"]` );
        if( lopdInputElement ) {
          lopdInputElement.addEventListener('click', () => {
            this.validateElement(lopdInputElement);
            this.isValidForm();
          });
          lopdInputElement.parentElement.appendChild(document.querySelector('.newsletter-link'));
        }
      }, 1500);
    }
  }


  validateElement(element) {
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let textfield_valid = element.getAttribute('value') !== '';
    let checkbox_valid = element.checked;
    let email_valid = element.getAttribute('id') == 'subscribe-email' && element.value !== '' && regex.test(element.value);

    if( element.parentElement.classList.contains('dropdown') && element.getAttribute('value') === '' ) {
      element.parentElement.classList.add('input--error');
      return false;
    } else if( element.classList.contains('textfield') && (!textfield_valid || !email_valid) ){
      element.classList.add('input--error');
      return false;

    } else if( element.classList.contains('checkbox') && !checkbox_valid ) {
      element.classList.add('input--error');
      return false;
    } else {
      element.classList.remove('input--error');
      return true;
    }
  }

  isValidForm() {
    let emailInputElement = document.querySelector( `.${this.formClass} input[name="subscribe-email"]` );
    let lopdInputElement = document.querySelector( `.${this.formClass} input[name="subscribe-lopd"]` );

    if( (!emailInputElement.classList.contains('input--error') && lopdInputElement == null) ||
        (!emailInputElement.classList.contains('input--error') && lopdInputElement != null && lopdInputElement.checked) ) {
      this.enableButton();
      return true;
    }

    this.disableButton();
    return false;
  }

  clearFieldsValues() {
    document.querySelectorAll(`.${this.formClass} input:not(.button)`).forEach(input => {
      if( input.parentElement.classList.contains('dropdown') ) {
        input.parentElement.querySelectorAll('.dropdown__text').forEach( ddt => {
          ddt.innerHTML = '';
        });
        input.parentElement.querySelectorAll('.dropdown__menu .item.selected').forEach( item => {
          item.classList.remove('selected');
        });
      } else if( input.classList.contains('textfield')) {
        input.parentElement.querySelector('button').click();
      } else if( input.classList.contains('checkbox') ) {
        input.checked = false;
      }
    });

    this.disableButton();
  }

  enableButton() {
    let submit_button = document.querySelector( `.${this.formClass} .newsletter--subscribe` );

    if (submit_button.classList.contains('button--disabled')) {
      submit_button.classList.remove('button--disabled');
      submit_button.classList.add('button--primary');
    }
  }

  disableButton() {
    let submit_button = document.querySelector( `.${this.formClass} .newsletter--subscribe` );

    if (submit_button.classList.contains('button--primary')) {
      submit_button.classList.remove('button--primary');
      submit_button.classList.add('button--disabled');
    }
  }

  hideSuccessMesage() {
    document.querySelector(`.${this.formClass} .${this.successClass}`).classList.add('hide');
  }

  showSuccessMesage() {
    document.querySelector(`.${this.formClass} .${this.successClass}`).classList.remove('hide');
  }

  confirmSubmit(msg) {
    console.log("submitted", msg);
  }
}

export default Newsletter
